@if (wsError.webServiceError) {
  <ion-row class="ion-text-center">
    @if (!wsError.noButtonsToShow) {
      <ion-col size="12">
        <ion-label class="ion-text-wrap ion-text-uppercase" color="white" translate>COMMON.ALERT</ion-label>
      </ion-col>
    }

    <ion-col size="12">
      @if (needToTranslate) {
        <ion-label
          class="ion-text-wrap"
          color="white"
          [innerHTML]="wsError.webServiceLabelError | translate"
        ></ion-label>
      } @else {
        <ion-label class="ion-text-wrap" color="white" [innerHTML]="wsError.webServiceLabelError"></ion-label>
      }
    </ion-col>

    @if (!wsError.noButtonsToShow) {
      <ion-col size="12">
        <ion-button fill="clear" class="buttonWithLato" size="small" (click)="toEmitRemoveWebServiceError()">
          <ion-label class="ion-text-wrap ion-text-uppercase" translate>COMMON.OK</ion-label>
        </ion-button>
      </ion-col>
    }
  </ion-row>

  @if (wsError.isLoadingMp3) {
    <ion-row>
      <ion-col size="12">
        <ion-label class="ion-text-wrap" translate>COMMON.DOWNLOADING_MP3</ion-label>
      </ion-col>
    </ion-row>
  }
}
